import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'covidTrackingOrglistSearchfilter'
})
export class CovidTrackingOrglistSearchfilterPipe implements PipeTransform {

  transform(items: any[], filter: string): any {

    if (!items || !filter) {
      return items;
    }
    items = items.filter(item => item.clinicalOrgName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.alreadyHaveCovidEnabeled.toLowerCase().indexOf(filter.toLowerCase()) !== -1 );
    return items;
  }
}
